import { HttpInterceptorFn } from '@angular/common/http';
import { getCurrentEnv } from '../core/http/env-utils';

/**
 * WCAG interceptor
 * - Matches any request path that contains a `wcag/` segment (e.g., `/wcag/...` or `wcag/...`)
 * - Rewrites it to the environment WCAG base (env.wcag) while preserving the query string
 * - Forces required headers for the WCAG API (Content-Type, Accept, x-auth-token)
 *
 * NOTE: Ensure this interceptor is registered BEFORE BaseUrlInterceptor so BaseUrl
 * does not capture `/wcag/...` and route it to the app base.
 */
export const WcagInterceptor: HttpInterceptorFn = (req, next) => {
  const isWcag = /(^|\/)wcag(\/|$)/i.test(req.url);
  if (!isWcag) {
    return next(req);
  }

  const env = getCurrentEnv();

  const WCAG_TOKEN =
    's1dyPegBUXkjdQqHhMqSEz8T3BlbkFJmlqgsFr41RqkgVApLHUXAoOdlEqeUXewkdrYn7wir2IdZaf';

  return next(
    req.clone({
      url: `${env.wcag}${req.url}`,
      setHeaders: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-auth-token': WCAG_TOKEN,
      },
    }),
  );
};
